import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { initialVideoFolderState } from '..';
import { moveFolderAsync } from '../../actions';
import { moveFolder, removeFolder } from '../../helpers';
import { VideoFolderActions } from '../../types';

const moveFolderReducer: Reducer<
  typeof initialVideoFolderState,
  VideoFolderActions
> = (state = initialVideoFolderState, action) => {
  switch (action.type) {
    case getType(moveFolderAsync.request): {
      const params = action.payload;
      return {
        ...state,
        moveFolder: {
          ...state.moveFolder,
          params,
          error: null,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(moveFolderAsync.success): {
      const { folderId, toParentId } = state.moveFolder.params!;

      return {
        ...state,
        data: removeFolder(state.data!, folderId),

        folderTree: {
          ...state.folderTree,
          data: moveFolder(state.folderTree.data!, folderId, toParentId)
        },

        moveFolder: {
          ...state.moveFolder,
          isPending: false
        }
      };
    }
    case getType(moveFolderAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        moveFolder: {
          ...state.moveFolder,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default moveFolderReducer;
